import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
} from '@mui/material';

const ACCOUNT_TYPE_CHOICES = ['Cash', 'Bank', 'Credit Card', 'Other'];
const CURRENCY_CHOICES = ['PKR', 'USD', 'AED', 'EUR', 'GBP'];

const MoneyAccountForm = ({ open, mode, formData, formErrors, onClose, onSubmit, onInputChange }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {mode === 'add' ? 'New Money Account' : mode === 'edit' ? 'Edit Money Account' : 'Money Account Details'}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Account Name"
              value={formData.name}
              onChange={(e) => onInputChange('name', e.target.value)}
              disabled={mode === 'view'}
              error={!!formErrors.name}
              helperText={formErrors.name}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth error={!!formErrors.account_type}>
              <InputLabel required>Account Type</InputLabel>
              <Select
                value={formData.account_type}
                label="Account Type"
                onChange={(e) => onInputChange('account_type', e.target.value)}
                disabled={mode === 'view'}
              >
                {ACCOUNT_TYPE_CHOICES.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.account_type && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                  {formErrors.account_type}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth error={!!formErrors.currency}>
              <InputLabel required>Currency</InputLabel>
              <Select
                value={formData.currency}
                label="Currency"
                onChange={(e) => onInputChange('currency', e.target.value)}
                disabled={mode === 'view'}
              >
                {CURRENCY_CHOICES.map((curr) => (
                  <MenuItem key={curr} value={curr}>
                    {curr}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.currency && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 2 }}>
                  {formErrors.currency}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Remarks"
              multiline
              rows={3}
              value={formData.remarks}
              onChange={(e) => onInputChange('remarks', e.target.value)}
              disabled={mode === 'view'}
              error={!!formErrors.remarks}
              helperText={formErrors.remarks}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.is_active}
                  onChange={(e) => onInputChange('is_active', e.target.checked)}
                  disabled={mode === 'view'}
                />
              }
              label="Active Account"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {mode !== 'view' && (
          <Button onClick={onSubmit} variant="contained">
            {mode === 'add' ? 'Create' : 'Update'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

MoneyAccountForm.propTypes = {
  open: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['add', 'edit', 'view']).isRequired,
  formData: PropTypes.object.isRequired,
  formErrors: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
};

export default MoneyAccountForm;